import { SECRETARY_ROOM } from './shareDraft.js';

/** Nome do Secretário no atalho de compartilhar (o do perfil; até carregar, o genérico). */
let secretaryTargetName = 'Meu Secretário';
export function setSecretaryTargetName(name: string): void {
  secretaryTargetName = name.trim().slice(0, 40) || 'Meu Secretário';
}

import { ClientEvent, RoomEvent, type MatrixClient } from 'matrix-js-sdk';
import { listConversations } from './matrix/rooms.js';
import { nativeBridge, nativeNotices } from './secretarioNative.js';

/**
 * Passa ao lado nativo o nome de cada conversa e as conversas mais recentes.
 * Os nomes montam o título do aviso de mensagem (o aviso que passa pelo
 * servidor de push não leva nome de ninguém); as recentes viram atalhos na
 * folha de compartilhar do Android. Nada disso sai do aparelho.
 */
export function watchRoomNames(client: MatrixClient): () => void {
  if (!nativeNotices()) return () => {};
  let lastNames = '';
  let lastTargets = '';
  let timer: ReturnType<typeof setTimeout> | null = null;
  const push = () => {
    // Mesmos nomes da lista de conversas (nas diretas, o nome da pessoa).
    const conversations = listConversations(client);
    const names: Record<string, string> = {};
    for (const item of conversations) names[item.roomId] = item.name.slice(0, 80);
    const namesJson = JSON.stringify(names);
    if (namesJson !== lastNames) {
      lastNames = namesJson;
      void nativeBridge.setRoomNames(names);
    }
    // O Secretário vem primeiro na fileira do "compartilhar"; depois, as conversas recentes.
    const targets = [
      { id: SECRETARY_ROOM, name: secretaryTargetName },
      ...conversations.slice(0, 3).map((item) => ({ id: item.roomId, name: item.name })),
    ];
    const targetsJson = JSON.stringify(targets);
    if (targetsJson !== lastTargets) {
      lastTargets = targetsJson;
      void nativeBridge.setShareTargets(targets);
    }
  };
  const schedule = () => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(push, 4000);
  };
  push();
  client.on(ClientEvent.Room, schedule);
  client.on(RoomEvent.Name, schedule);
  client.on(RoomEvent.MyMembership, schedule);
  client.on(RoomEvent.Timeline, schedule);
  return () => {
    if (timer) clearTimeout(timer);
    client.off(ClientEvent.Room, schedule);
    client.off(RoomEvent.Name, schedule);
    client.off(RoomEvent.MyMembership, schedule);
    client.off(RoomEvent.Timeline, schedule);
  };
}
